<template lang="pug">
  v-row(no-gutters class="mb-4")
    v-col(cols="12")
      h1(class="text-title pb-10 pt-4") {{ title }}
      v-card(id="advert-card" outlined)
        v-card-text(class="pa-0")
          v-row(no-gutters)
            v-col(cols="8")
              v-img(v-if="advertItem.images", :src="advertItem.images[0]", height=405, @click.prevent="handleShow" style="cursor:pointer")
              v-img(v-else, :src="require('@/assets/images/noimage.png')", height=405, aspect-ratio=1.7 )
            v-col(cols="4" class="px-11 py-4 d-flex flex-column justify-space-between")
              div
                div(class="text-grey text-center mb-11") {{ city }} {{ advertItem.address }}
                v-row(justify="center")
                  div(class="text-price") {{ price }}
                    div(class="text-right pt-1") {{ price !== 'Цена договорная' ? duration : null }}
              div(v-if="isAuthorAdvert", class="d-flex flex-column align-center")
                v-btn(
                  class="mb-4",
                  depressed,
                  width="144",
                  color="#FFDC26",
                  :to="`/advert/item/edit/${advertItem.id}`") Редактировать
                v-btn(
                  color="error",
                  width="144",
                  outlined,
                  :loading="loading",
                  @click.prevent="removeAdvert") Удалить
              div(v-else)
                v-btn(
                  v-if="!showTel",
                  block,
                  large,
                  depressed,
                  class="font-weight-bold",
                  color="#B0DF5B",
                  @click="showTel = true") Показать #[span(class="text-lowercase pl-1") телефон]
                v-btn(
                  v-else,
                  disabled,
                  depressed,
                  large,
                  block) {{ '+' + parseInt(advertItem.phone).toLocaleString('ru-Ru') }}
              div
                v-row(no-gutters justify="center" class="mb-3")
                  v-icon(color="#B9B9B9" class="mr-2") account_circle
                  span Частное лицо
                v-row(no-gutters justify="center")
                  div(class="mr-4")
                    v-icon(class="mr-2" color="#B9B9B9") visibility
                    span(class="text-views") {{ advertItem.countViews }}
                  div
                    span(class="text-views") {{ advertItem.creationDate }}
    VueEasyLightbox(escDisabled :visible="visible", :imgs="advertItem.images", @hide="handleHide")
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'
export default {
  name: 'PageMainCard',
  components: {
    VueEasyLightbox
  },
  props: {
    advertItem: {
      type: Object,
      default: () => ({})
    },
    city: {
      type: String,
      default: ''
    },
    price: {
      type: String,
      default: ''
    },
    isAuthorAdvert: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    duration: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    showTel: false,
    visible: false,
    loading: false
  }),
  methods: {
    handleHide() {
      this.visible = false
    },
    handleShow() {
      this.visible = true
    },
    removeAdvert() {
      this.loading = true
      this.$store
        .dispatch('DELETE_ADVERT', {
          type: this.advertItem.advertType,
          id: this.advertItem.id
        })
        .then(response => {
          if (response.success) {
            this.$router.push({ path: '/' })
          }
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>

<style lang="scss" scoped>
.text {
  &-title {
    font-size: 24px;
    letter-spacing: -1.6px;
    color: #292929;
  }
  &-grey {
    font-size: 12px;
    line-height: 16px;
    color: #8e8e93;
  }
  &-price {
    font-size: 32px;
    font-weight: 700;
    color: #000000;
  }
}
.theme--light.v-btn.v-btn--disabled {
  color: #333 !important;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}
</style>
